import React from 'react';
import styled from 'styled-components';
import {connect} from 'react-redux';
import './SeatsSelection.css';

const ScreenLabel = styled.div`
    color: var(--primary);
    font-size: 0.9em;
    left: 50%;
    letter-spacing: 1em;
    line-height: 1em;
    padding: 0 1em 0 2em;
    position: absolute;
    text-align: center;
    text-transform: uppercase;
    top: -1.5em;
    transform: translateX(-50%);
    width: auto;
`;

const ScreenImageWrapper = styled.div`
    height: 100%;
    left: 50%;
    overflow: hidden;
    position: absolute;
    transform: translateX(-50%);
    top: 0;
    width: 100%;
`;

const ScreenImage = styled.img`
    height: auto;
    left: 50%;
    position: absolute;
    transform: translateX(-50%);
    top: 0;
    width: 1000px;
`;

class SeatsScreen extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return this.props.screenImage
              ? <ScreenImageWrapper><ScreenImage src={this.props.screenImage.image_light}/></ScreenImageWrapper>
              : <ScreenLabel>Pantalla</ScreenLabel>
  }
}

const mapStateToProps = state => ({
  screenImage: state.checkoutData.data.screen_override || null,
});

export default connect(
  mapStateToProps
)(SeatsScreen);